import React, { Component } from "react";

import airbrakeNotifier from "@services/airbrake";

const ErrorFallback = () => (
  <div className="container mt-5">
    <section className="text-center">
      <h1 className="jumbotron-heading text-theme-primary">Something went wrong!</h1>
      <p className="lead text-muted mb-5">
        Our team has been notified, meanwhile you may refresh the page or try again later.
      </p>
    </section>
  </div>
);

class AirbrakeErrorBoundary extends Component {
  state = { hasError: false };

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    airbrakeNotifier.notify({ error, params: { info } });
  }

  render() {
    const { fallback = "", useDefault, children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return useDefault ? <ErrorFallback /> : fallback;
    }

    return children;
  }
}

export default AirbrakeErrorBoundary;
